import styled from "styled-components";

import { Search } from "shared/molecules/Search";

export const StyledSearch = styled(Search)`
  flex-grow: 2;
  ${props => props.theme.belowBreakpoint} {
    width: 100%;
  }
`;
